import * as React from 'react';
import './PageHeader.scss'

type SideNavigationItem = {
  title: string;
  description: string;
};

export const PageHeader = ({ title, description }: SideNavigationItem) => {


  return (
    <div className='header-container'>
      <div className='header-title'>
        {title}

      </div>
      <div className='header-description'>
        {description}

      </div>
    </div>

  );
};
